module.exports = __webpack_public_path__ + "static/media/cloud.1516ea98.gif";